<nav class="breadcrumb-container" aria-label="breadcrumb">
  <ng-container *ngFor="let item of currentBreadcrumbs; let last = last">
    <button
      class="breadcrumb-label"
      [class.last]="last"
      [attr.aria-current]="last ? 'page' : null"
      mat-button
      type="button"
      (click)="openFolder(item)"
      [disabled]="!item">
      {{ item?.name || '' }}
    </button>
    <mat-icon *ngIf="!last" class="breadcrumb-separator" aria-hidden="true">chevron_right</mat-icon>
    <button *ngIf="last" mat-icon-button
            color="primary"
            class="breadcrumb-add-btn"
            [matMenuTriggerFor]="folderListPopover"
            [attr.aria-label]="translate('breadcrumbs.popover.open_menu') || 'Abrir menú'"
            >
      <mat-icon>expand_more</mat-icon>
    </button>
  </ng-container>
</nav>


<mat-menu #folderListPopover="matMenu" class="scrollable-menu">
  <button mat-menu-item (click)="openCreateFolderDialog(dialogTemplate)">
    <mat-icon>add_circle_outline</mat-icon>
    <span>{{ translate('breadcrumbs.popover.create_option') }}</span>
  </button>
  <mat-divider></mat-divider>
  <ng-container *ngFor="let item of currentChildren">
    <button mat-menu-item (click)="openFolder(item)" [disabled]="!item">
      <mat-icon>folder</mat-icon>
      <span>{{ item?.name || '' }}</span>
    </button>
  </ng-container>
</mat-menu>


<ng-template #dialogTemplate let-dialogRef="dialogRef">
  <h2 mat-dialog-title>{{ translate('breadcrumbs.modal.title') || 'Crear nueva carpeta' }}</h2>
  <form (ngSubmit)="createFolder(dialogRef)" #folderForm="ngForm" style="padding: 0 24px 24px 24px;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>{{ translate('breadcrumbs.modal.label') }}</mat-label>
      <input matInput [(ngModel)]="newFolderName" name="folderName" required>
    </mat-form-field>
    <div *ngIf="createFolderError" class="error-message">
      <mat-icon>error</mat-icon>
      {{ createFolderError }}
    </div>
    <div style="margin-top: 16px; text-align: right;">
      <button mat-button mat-dialog-close type="button">{{ translate('breadcrumbs.modal.button.cancel') }}</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="!newFolderName">{{ translate('breadcrumbs.modal.button.create') }}</button>
    </div>
  </form>
</ng-template>